import { useEffect, useState } from "react";
import "./MindMappingReportAThirdSection.css";

const MindMappingReportAThirdSection = ({ res,toggle }) => {
  const [sectorData, setSectorData] = useState({
    level: "",
    category: "",
    userSector: ""
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);

  useEffect(() => {
    if (!res?.sector_type) return;

    const type = res.sector_type.toLowerCase();
    
    // Accessibility Mapping for Sectors
    const sectorMapping = {
      tertiary: {
        level: "⭐⭐⭐\n⭐⭐ \n Very High",
        category: "Tertiary (Services, Tech, Consulting)"
      },
      secondary: {
        level: "⭐⭐⭐ Medium",
        category: "Secondary (Manufacturing, Construction)"
      },
      primary: {
        level: "⭐⭐ Low–Medium",
        category: "Primary (Agriculture, Mining, Raw Materials)"
      }
    };

    const match = sectorMapping[type] || {
      level: "N/A",
      category: "Unknown Sector Type"
    };

    setSectorData({
      level: match.level,
      category: match.category,
      userSector: res.sector || "Not Specified"
    });

  }, [res]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="mind-mapping-report-a-third-container">
      <div className={toggle?"table-adjust":"mind-mapping-report-a-third-final-table"}> 
        {/* Decorative Corners */}
        <span className="mind-mapping-report-a-third-corner mind-mapping-report-a-third-corner-top-left"></span>
        <span className="mind-mapping-report-a-third-corner mind-mapping-report-a-third-corner-top-right"></span>
        <span className="mind-mapping-report-a-third-corner mind-mapping-report-a-third-corner-bottom-left"></span>
        <span className="mind-mapping-report-a-third-corner mind-mapping-report-a-third-corner-bottom-right"></span>

        <div className="mind-mapping-report-a-third-module-title">
           <span className="module-prefix">Module 3:</span>  Sector Accessibility (Founder View)
        </div>

        {/* 3A: Sector Accessibility Table */}
        <div className="mind-mapping-report-a-third-table-scroll-wrapper">
          <table className="mind-mapping-report-a-third-inner-table">
            <thead>
              <tr>
                <th className="mind-mapping-report-a-third-col-sno">S.NO</th>
                <th>Accessibility Level</th>
                <th>Sector Category</th>
                <th>Specific Industry</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="mind-mapping-report-a-third-col-sno">3 A</td>
                <td className="mind-mapping-report-a-third-highlight">
                  {isMobile ? (
                    sectorData.level.split('\n').map((line, index) => (
                      <span key={index}>
                        {line}
                        {index < sectorData.level.split('\n').length - 1 && <br />}
                      </span>
                    ))
                  ) : (
                    sectorData.level
                  )}
                </td>
                <td>{sectorData.category}</td>
                <td className="mind-mapping-report-a-third-user-val">
                  {sectorData.userSector}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MindMappingReportAThirdSection;